<script lang="ts">
    import type {Injector} from '../svelte/types';
    import {getContext} from 'svelte';
    import {INJECTOR_KEY} from '../svelte/utils';
    import {KpFiltersPresenter} from './kp-filters.presenter';
    import KpLoadingBlock from '../commons/components/kp-loading/KpLoadingBlock.svelte';
    import KpFilterItem from './KpFilterItem.svelte';

    const injector: Injector = getContext(INJECTOR_KEY);
    const presenter: KpFiltersPresenter = injector.getByToken(KpFiltersPresenter.presenterName);
</script>


<div class="row">
    <div class="col-xs-12">
        <h1>Filtry</h1>
    </div>
</div>

<div class="row">
    <div class="col-xs-12">
        {#await presenter.getFilters()}
            <KpLoadingBlock/>
        {:then filters}
            {#each filters as filter (filter.id)}
                <KpFilterItem {filter} />
            {/each}
        {/await}
    </div>
</div>